import React, { useEffect, useState } from "react";
import LeagueTeamTable from "./LeagueTeamTable";
import { loadStyles } from "../../../utils/cssLoader";

const LeagueTeamWrapper = ({
  data,
  loadCSS,
  dataClient = false,
  baseUrl,
  websiteBaseUrl,
  dataPath,
  title,
  id,
  matchType = "league",
  sport,
}) => {
  const [clientData, setClientData] = useState(null);
  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);
  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("livematchdetail");
    }
  }, [loadCSS]);

  const sourceData = dataClient ? clientData : data;

  return (
    <>
      {title && <h1>{title}</h1>}

      <LeagueTeamTable data={sourceData?.data} />
    </>
  );
};

export default LeagueTeamWrapper;
